import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineProductsRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.products, ['code']),
  getByExactCode: async (code: string) => {
    const product = offlineDatabase.products
      .filter((product) => product.code.toLocaleLowerCase() === code.toLocaleLowerCase())
      .first();
    return product;
  },
};
